import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installBugLog } from './utils/bugLog';

// Capture console output + window errors from first paint, so a bug report can
// attach recent logs/events (see components/BugReporter.tsx).
installBugLog();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
